__turbopack_context__.v({
  "button": "SpotlightRow-module__SFRo9G__button",
  "cards": "SpotlightRow-module__SFRo9G__cards",
  "content": "SpotlightRow-module__SFRo9G__content",
  "description": "SpotlightRow-module__SFRo9G__description",
  "main": "SpotlightRow-module__SFRo9G__main",
  "title": "SpotlightRow-module__SFRo9G__title",
});
